import {Component, OnInit} from '@angular/core';
import {DrinkMachineStorageService} from "../Services/DrinkMachineService/drink-machine-config-service";
import {CoinChange} from "./coin-change-model";

@Component({
  selector: 'app-drink-automatic-machine',
  templateUrl: './drink-automatic-machine.component.html',
  styleUrls: ['./drink-automatic-machine.component.css']
})
export class DrinkAutomaticMachineComponent implements OnInit {

  drinkPriceToShow = 2.40;

  drinkPriceNeedToPay = 0;

  balanceToGive = 0;

  totallyPaid = 0;

  hasSufficientChange: boolean = true;


  balInTwoEuro:number = 0;
  balInOneEuro:number= 0;
  balInFiftyCent:number= 0;
  balInTwentyCent:number= 0;
  balIn10Cent:number= 0;


  constructor(private _drinkMachineStorageService: DrinkMachineStorageService) {

  }


  ngOnInit() {

    this._drinkMachineStorageService.fetchAndStoreCoinInfo();
    this._drinkMachineStorageService.fetchAndStoreDrinkInfo();

    this.drinkPriceNeedToPay = this.drinkPriceToShow;

  }


  /**
   * We detect the changes in UI and show the according price for
   * the choosen product ID.
   *
   * @param drinkId
   */
  fetchDrinkPrice(drinkId: number) {

    this._drinkMachineStorageService.drinkInfoLocalStorage.forEach(
      drinkInfo => {

        if (drinkInfo.drinkId == drinkId) {
          this.drinkPriceToShow = drinkInfo.drinkPrice;
          this.drinkPriceNeedToPay = drinkInfo.drinkPrice;

          //TODO break from for each loop after finding.
        }

      }
    );
  }


  /**
   *
   * add thrown coin values to check paid and need to
   * pay values
   *
   * @param coinValue
   */
  addThrownCoinValue(coinValue: number) {

    this.totallyPaid = this.totallyPaid + coinValue;

    this.drinkPriceNeedToPay = this.drinkPriceNeedToPay - coinValue;

    if (this.drinkPriceNeedToPay < 0) {

      this.balanceToGive = Math.abs(this.drinkPriceNeedToPay);

      this.analyzeAndGiveChange();
    }


  }


  /**
   * MAIN LOGIC:
   * analyze the paid and balance values to pay back using
   * available coins.
   */
  analyzeAndGiveChange() {

    let coinChange: Array<CoinChange> = [];


    if (this.balanceToGive > 0) {

      let balance: number = this.balanceToGive;


      while (balance > 0) {

        if (balance >= 2.0 && this.hasEnoughCoins(2.0)) {

          console.log("add 2 euro");

           coinChange.push(new CoinChange(2.0));

          balance = balance - 2.0;
          balance = parseFloat(balance.toFixed(1));

          this.deduceTheAmountOfCoins(2.0);

          continue;

        } else if (balance >= 1.0 && this.hasEnoughCoins(1.0)) {

          console.log("add 1 euro");

          coinChange.push(new CoinChange(1.0));

          balance = balance - 1.0;

          balance = parseFloat(balance.toFixed(1));

          this.deduceTheAmountOfCoins(1.0);

          continue;

        } else if (balance >= 0.50 && this.hasEnoughCoins(0.50)) {

          console.log("add 50 cent");

          coinChange.push(new CoinChange(0.50));

          balance = balance - 0.50;

          this.deduceTheAmountOfCoins(0.50);

          balance = parseFloat(balance.toFixed(1));

          continue;


        } else if (balance >= 0.20 && this.hasEnoughCoins(0.20)) {

          console.log("add 20 cent")

          coinChange.push(new CoinChange(0.20));

          balance = balance - 0.20;

          this.deduceTheAmountOfCoins(0.20);

          balance = parseFloat(balance.toFixed(1));

          continue;

        } else if (balance >= 0.10 && this.hasEnoughCoins(0.10)) {

          console.log("add 10 cent " + balance);

          coinChange.push(new CoinChange(0.10));

          balance = balance - 0.10;

          this.deduceTheAmountOfCoins(0.10);

          balance = parseFloat(balance.toFixed(1));

          continue;

        } else {

          console.log("not sufficient " + balance);

          this.hasSufficientChange = false;

          break;
        }

      }


    }

    if(this.hasSufficientChange == true){

      this.prepareCoinChangeUI(coinChange);
      this.totallyPaid = 0;
    }




  }

  /**
   *
   * calculating the amount of coins to show in FrontEnd.
   *
   * @param coinChange
   */
  private prepareCoinChangeUI(coinChange: Array<CoinChange>) {
    if (coinChange.length > 0) {

      coinChange.forEach(coinInfo => {

        console.log("coin info " + coinInfo.coinValue);

        if (coinInfo.coinValue == 2.0) {

          this.balInTwoEuro = this.balInTwoEuro + 1;
        } else if (coinInfo.coinValue == 1.0) {

          this.balInOneEuro = this.balInOneEuro + 1;
        } else if (coinInfo.coinValue == 0.50) {
          this.balInFiftyCent = this.balInFiftyCent + 1;
        } else if (coinInfo.coinValue == 0.20) {

          this.balInTwentyCent = this.balInTwentyCent + 1;

        } else if (coinInfo.coinValue == 0.10) {

          this.balInTwentyCent = this.balInTwentyCent + 1;
        }

      })

    }
  }


  /**
   *
   * Checks whether we have enough coins in the machine, by comparing
   * in the In-Memory.
   *
   * @param coin
   * @returns {boolean}
   */
  hasEnoughCoins(coin: number): boolean {

    let available: boolean = false;


    this._drinkMachineStorageService.coinInfoLocalStorage.forEach(coinInfo => {

      if (coinInfo.coinValue == coin) {

        if (coinInfo.numberOfCoinsAvailable > 0) {

          available = true

          //TODO end the for each loop

        }

      }

    })

    return available;

  }


  /**
   *
   * deduce the number of coins in the machine, whenever we pay
   * the balance
   *
   * @param coinVal
   */

  deduceTheAmountOfCoins(coinVal:number){

    this._drinkMachineStorageService.coinInfoLocalStorage.forEach(coinInfo =>{

      if(coinInfo.coinValue == coinVal){

        coinInfo.numberOfCoinsAvailable = coinInfo.numberOfCoinsAvailable-1;

      }

    })


  }

}



// WEBPACK FOOTER //
// /Applications/WebStorm.app/Contents/bin/untitled3/Users/vidhyasagar/WebstormProjects/RealTimeAnalytics/CoinMachine/src/app/drink-automatic-machine/drink-automatic-machine.component.ts